import { Receipt } from "lucide-react";
import { mxn } from "@/lib/format";

// Datos de la factura en SOLO LECTURA (solicitud sellada y Comité de Crédito).
export function FactorajeExposicion({ exposicion, testid = "factoraje-exposicion" }) {
  if (!exposicion) return null;
  const excede = !!exposicion.excede;
  return (
    <p data-testid={testid}
      className={`rounded-md border px-3 py-1.5 text-xs ${excede
        ? "border-red-200 bg-red-50 text-red-800" : "border-slate-200 bg-slate-50 text-slate-700"}`}>
      Exposición del deudor: <b>{mxn(exposicion.total)}</b> de{" "}
      <b>{exposicion.limite != null ? mxn(exposicion.limite) : "—"}</b>
      <span className="text-slate-500"> (en trámite y vigente {mxn(exposicion.otras)} + esta operación {mxn(exposicion.actual)})</span>
      {excede && <b className="ml-1">· Supera el límite por deudor: no se puede enviar al Comité.</b>}
    </p>
  );
}

export function FactorajeResumen({ factoraje, exposicion, testid = "factoraje-resumen" }) {
  if (!factoraje) return null;
  const filas = [
    ["Deudor", `${factoraje.deudor_nombre || "—"}${factoraje.deudor_rfc ? ` · ${factoraje.deudor_rfc}` : ""}`],
    ["UUID del CFDI", factoraje.cfdi_uuid || "—"],
    ["Valor nominal", mxn(factoraje.valor_nominal)],
    ["Vencimiento", factoraje.fecha_vencimiento_factura || "—"],
    ["Aforo", factoraje.aforo_pct != null ? `${factoraje.aforo_pct}%` : "—"],
    ["Anticipo", mxn(factoraje.anticipo)],
  ];
  return (
    <div data-testid={testid} className="rounded-lg border border-indigo-200 bg-indigo-50/40 p-3">
      <p className="mb-2 flex items-center gap-2 font-heading text-sm font-semibold text-slate-800">
        <Receipt className="h-4 w-4 text-indigo-600" /> Datos de la factura
      </p>
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
        {filas.map(([l, v]) => (
          <div key={l} className="rounded-md border border-slate-100 bg-white p-2">
            <p className="text-[10px] uppercase tracking-wide text-slate-500">{l}</p>
            <p className="mt-0.5 break-all text-sm font-semibold text-slate-800"
              data-testid={`${testid}-${l.toLowerCase().replace(/\s+/g, "-")}`}>{v}</p>
          </div>
        ))}
      </div>
      <div className="mt-2"><FactorajeExposicion exposicion={exposicion} testid={`${testid}-exposicion`} /></div>
    </div>
  );
}
